module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hres7de-detail"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP1']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setYearOutput(_vm.searchIndex.year)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.codcours) + " - " + _vm._s(_vm.indexSelected.name))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.numclseq))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('detail-tab1', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "detailTab1": _vm.detail.tab1,
      "detailTab1PopupBtn1to3Columns": _vm.detailTab1PopupBtn1to3Columns,
      "detailTab1PopupBtn4Columns": _vm.detailTab1PopupBtn4Columns,
      "detailTab1Popup": _vm.detailTab1Popup,
      "receivedHres7deDetailTab1Popup": _vm.receivedHres7deDetailTab1Popup
    }
  }), _vm._v(" "), _c('detail-tab2', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "codeval": _vm.codeval,
      "detailTab2": _vm.detail.tab2,
      "postHres7deTab2Save": _vm.postHres7deTab2Save,
      "indexSelected": _vm.indexSelected,
      "searchIndex": _vm.searchIndex,
      "searchDetail": _vm.searchDetail
    }
  }), _vm._v(" "), _c('detail-tab3', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "labelsButton": _vm.labelsButton,
      "codeval": _vm.codeval,
      "detailTab3": _vm.detail.tab3,
      "detailTab3MaxRowspan": _vm.detailTab3MaxRowspan,
      "detailTab3Columns": _vm.detailTab3Columns,
      "detailTab3Selected": _vm.detailTab3Selected,
      "setDetailTab3Selected": _vm.setDetailTab3Selected,
      "detailTab3Popup": _vm.detailTab3Popup,
      "receivedHres7deDetailTab3Popup": _vm.receivedHres7deDetailTab3Popup,
      "searchIndex": _vm.searchIndex,
      "indexSelected": _vm.indexSelected,
      "postHres7deTab3PopupSave": _vm.postHres7deTab3PopupSave,
      "searchDetail": _vm.searchDetail
    }
  }), _vm._v(" "), _c('detail-tab4', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "detailTab4": _vm.detail.tab4,
      "searchIndex": _vm.searchIndex,
      "indexSelected": _vm.indexSelected,
      "postHres7deTab4Save": _vm.postHres7deTab4Save,
      "searchDetail": _vm.searchDetail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1fa0d12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7de/detail.vue
// module id = 3945
// module chunks = 1